var _symbol;
var _excluded = ["title", "titleId"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablerSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-affiliate",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.683 12.317l5.759 -5.759"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-alert_circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-arrow_right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 6,
    x2: 19,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-baby_carriage",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17l1 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14l1 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-briefcase",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13a20 20 0 0 0 18 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-building_bank",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 6 12 3 19 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 8,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 17
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-businessplan",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 6,
    rx: 5,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v1m0 -8v1"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-cash",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 14,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-chart_area_line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 19 8 13 12 15 16 10 20 14 20 19 4 19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 12 7 8 11 10 16 4 20 8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-chart_line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 15 8 9 12 11 16 6 20 10"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-eye",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-hourglass",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-lifebuoy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 18.35,
    y2: 18.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 5.65,
    y2: 18.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.65,
    y1: 5.65,
    x2: 9,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.35,
    y1: 5.65,
    x2: 15,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-messages",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-message",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 14,
    y2: 13
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-notebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 8,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 15,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-plant",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9a10 10 0 1 0 20 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19a10 10 0 0 1 10 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9a10 10 0 0 1 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4a9.7 9.7 0 0 1 2.99 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-school",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9l-10 -4l-10 4l10 4l10 -4v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-user",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-user-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11h6m-3 -3v6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-users",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21v-2a4 4 0 0 0 -3 -3.85"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-world",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 9,
    x2: 20.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 20.4,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3a17 17 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3a17 17 0 0 1 0 18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-yoga",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4l1.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20l-1 -5h-5l1 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10l4 -1l4 -1l4 1.5l4 1.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-logout",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h14l-3 -3m0 6l3 -3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-chevron-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15l6 -6l6 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-chevron-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-chevron_right",
    viewBox: "0 0 24 24",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6l6 6l-6 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-chevron_left",
    viewBox: "0 0 24 24",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l-6 6l6 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-search",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-adjustments-horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 12,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 6,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 15,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 18,
    x2: 20,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-mood-sad",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 6,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 18,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-layout-grid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-list",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 20,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 6,
    x2: 5,
    y2: 6.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 5,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 18,
    x2: 5,
    y2: 18.01
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-visa",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12H10V16H7V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V19C3 19.2652 3.10536 19.5196 3.29289 19.7071C3.48043 19.8946 3.73478 20 4 20H20C20.2652 20 20.5196 19.8946 20.7071 19.7071C20.8946 19.5196 21 19.2652 21 19V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6H14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10 3.73478 10.1054 3.48043 10.2929 3.29289C10.4804 3.10536 10.7348 3 11 3H13C13.2652 3 13.5196 3.10536 13.7071 3.29289C13.8946 3.48043 14 3.73478 14 4V7C14 7.26522 13.8946 7.51957 13.7071 7.70711C13.5196 7.89464 13.2652 8 13 8H11C10.7348 8 10.4804 7.89464 10.2929 7.70711C10.1054 7.51957 10 7.26522 10 7V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16H16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12H18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-heart_handshake",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5013 12.5719L12.0013 19.9999L4.50128 12.5719C4.00658 12.0905 3.61692 11.5119 3.35683 10.8726C3.09673 10.2332 2.97184 9.54688 2.99002 8.85687C3.00819 8.16685 3.16904 7.48807 3.46244 6.86327C3.75583 6.23847 4.17541 5.68119 4.69476 5.22651C5.21411 4.77184 5.82198 4.42962 6.48009 4.22141C7.1382 4.01321 7.83228 3.94352 8.51865 4.01673C9.20501 4.08995 9.86878 4.30449 10.4682 4.64684C11.0675 4.98919 11.5895 5.45193 12.0013 6.00593C12.4148 5.45595 12.9374 4.99725 13.5364 4.65854C14.1353 4.31982 14.7978 4.10838 15.4822 4.03745C16.1666 3.96652 16.8584 4.03763 17.5141 4.24632C18.1697 4.45502 18.7753 4.79681 19.2928 5.2503C19.8104 5.70379 20.2287 6.25922 20.5217 6.88182C20.8147 7.50443 20.976 8.18082 20.9956 8.86864C21.0152 9.55647 20.8925 10.2409 20.6354 10.8792C20.3783 11.5174 19.9922 12.0958 19.5013 12.5779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6L8.70685 9.293C8.51938 9.48053 8.41406 9.73484 8.41406 10C8.41406 10.2652 8.51938 10.5195 8.70685 10.707L9.24985 11.25C9.93985 11.94 11.0598 11.94 11.7498 11.25L12.7498 10.25C13.3466 9.65327 14.1559 9.31803 14.9998 9.31803C15.8438 9.31803 16.6531 9.65327 17.2498 10.25L19.4998 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5L14.5 17.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13L17 15"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-message_star",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9H16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13H12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19L9 18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7983 20.817L15.6263 21.955C15.5618 21.9885 15.4893 22.0035 15.4168 21.9982C15.3444 21.9929 15.2748 21.9676 15.2159 21.9251C15.157 21.8826 15.111 21.8245 15.0832 21.7574C15.0554 21.6903 15.0467 21.6167 15.0583 21.545L15.4733 19.134L13.7163 17.427C13.6638 17.3763 13.6267 17.3119 13.6091 17.2411C13.5915 17.1703 13.5942 17.096 13.6168 17.0266C13.6395 16.9573 13.6811 16.8957 13.7371 16.8489C13.7931 16.8021 13.861 16.772 13.9333 16.762L16.3613 16.41L17.4473 14.217C17.4798 14.1517 17.5298 14.0967 17.5918 14.0583C17.6538 14.0199 17.7253 13.9995 17.7983 13.9995C17.8712 13.9995 17.9427 14.0199 18.0047 14.0583C18.0667 14.0967 18.1168 14.1517 18.1493 14.217L19.2353 16.41L21.6633 16.762C21.7353 16.7723 21.803 16.8027 21.8587 16.8495C21.9144 16.8963 21.9559 16.9578 21.9785 17.027C22.0011 17.0962 22.0039 17.1703 21.9865 17.241C21.9691 17.3117 21.9323 17.3761 21.8803 17.427L20.1233 19.134L20.5373 21.544C20.5497 21.6158 20.5417 21.6898 20.5143 21.7573C20.4868 21.8249 20.4409 21.8834 20.3819 21.9262C20.3228 21.969 20.253 21.9944 20.1802 21.9995C20.1074 22.0046 20.0347 21.9891 19.9703 21.955L17.7983 20.817Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-flight",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.50012L17.5 3.60012C17.8846 3.21556 18.4061 2.99951 18.95 2.99951C19.4939 2.99951 20.0154 3.21556 20.4 3.60012C20.7846 3.98469 21.0006 4.50627 21.0006 5.05012C21.0006 5.59398 20.7846 6.11556 20.4 6.50012L17.5 9.50012L20 17.0001L17.5 19.5501L14 13.0001L11 16.0001V19.0001L9 21.0001L7.5 16.5001L3 15.0001L5 13.0001H8L11 10.0001L4.5 6.50012L7 4.00012L14.5 6.50012Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-books",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l4 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16l3.923 -.98"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-wallet",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v4h-4a2 2 0 0 1 0 -4h4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-mood_happy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9l.01 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9l.01 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13a4 4 0 1 0 8 0h-8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-pencil",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5l4 4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-arrow_left",
    viewBox: "0 0 24 24",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l14 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l6 -6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-phone",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.512 7C19.058 7 17 9.031 17 11.453v41.094C17 54.969 19.058 57 21.512 57h20.976C44.942 57 47 54.969 47 52.547V11.453C47 9.031 44.942 7 42.488 7H21.512zm7.915 4.297h4.987c.317 0 .633.39.633.86 0 .468-.237.859-.633.859h-4.987c-.316 0-.633-.391-.633-.86s.317-.86.633-.86zm-9.973 5.937h25.013v29.532H19.454V17.234zM31.96 49.11c1.504 0 2.77 1.25 2.77 2.735 0 1.484-1.266 2.734-2.77 2.734s-2.77-1.25-2.77-2.734c0-1.485 1.266-2.735 2.77-2.735z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-flexible",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.955 11.75c5.016 0 8.99 5.807 12.63 17.128l.632 1.998C37.342 40.573 40.6 45.25 43.36 45.25c2.959 0 6.99-5.093 11.418-15.531a2 2 0 1 1 3.682 1.562l-.444 1.034C53.132 43.53 48.453 49.25 43.36 49.25c-5.202 0-9.304-5.825-12.945-17.13l-.325-1.026c-3.212-10.336-6.514-15.344-9.135-15.344-2.698 0-6.432 5.078-10.449 15.471a2 2 0 0 1-3.73-1.442c4.615-11.94 9.09-18.029 14.18-18.029z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-future",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.412 32c0 1.715-.306 3.385-.867 4.965l4.283 1.399A17.933 17.933 0 0 0 52 32h-4.588zM42 43.761l2.628 2.784a19.56 19.56 0 0 0 3.736-4.949l-3.531-1.414c-.74 1.37-1.724 2.563-2.833 3.58zM33.862 52a19.269 19.269 0 0 0 7.229-2.528l-2.953-2.927c-1.367.666-2.777 1.153-4.32 1.42L33.862 52zm-3.308 0l-.044-4c-8.153-.667-14.544-7.556-14.544-15.956 0-8.844 7.14-16 15.866-16 5.024 0 9.475 2.356 12.384 6.045l-4.01 4.044H51.09V15.156L47.036 19.2c-3.613-4.4-9.078-7.2-15.204-7.2C20.902 12 12 20.978 12 32.044 12 42.622 20.197 51.334 30.554 52z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.818 32.664V30.6H32.455V19.273h-4.091v15.454h15.454z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-save",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.056 14.884H13.86a1.33 1.33 0 0 1-1.35-1.337 1.33 1.33 0 0 1 1.35-1.338h34.068c.918 0 1.62-.695 1.62-1.604 0-.91-.702-1.605-1.62-1.605H12.78C10.674 9 9 10.658 9 12.744v33.751c0 1.07.864 1.926 1.944 1.926H15.1A14.254 14.254 0 0 0 27.14 55c5.075 0 9.502-2.62 12.04-6.58h13.875c1.08 0 1.944-.855 1.944-1.925V16.81c0-1.07-.864-1.925-1.944-1.925zM27.141 52.326c-6.371 0-11.554-5.135-11.554-11.447 0-.481.054-.963.108-1.444.702-5.723 5.615-10.002 11.446-10.002 1.512 0 2.97.267 4.32.802 4.426 1.765 7.234 5.937 7.234 10.644 0 6.312-5.183 11.447-11.554 11.447zm24.89-24.338H41.448c-1.997 0-3.617-1.604-3.617-3.583 0-1.98 1.62-3.584 3.617-3.584h10.583v7.167zm-11.77-3.583a1.56 1.56 0 0 0 1.565 1.55 1.56 1.56 0 0 0 1.566-1.55 1.56 1.56 0 0 0-1.566-1.552 1.56 1.56 0 0 0-1.565 1.552z",
    fillRule: "nonzero",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.227 8.584a1 1 0 0 1 1.546 1.27C11.21 15.411 5.86 15.411.298 9.93a1 1 0 0 1 1.404-1.425c4.757 4.688 8.74 4.688 12.525.078z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 2.5,
    r: 2.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.5,
    r: 2.5,
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-green_tick_filled",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
    fill: "#95BC3D",
    stroke: "#95BC3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12l2 2l4 -4",
    fill: "#95BC3D",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-calendar",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-burger",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6l16 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12l16 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18l16 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-close",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6l-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l12 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-plus",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5l0 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l14 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-minus",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l14 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tabler-dollar-in-circle",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerSprite);
export default __webpack_public_path__ + "static/media/tablerSprite.b57e453e25f697c1abc035f7fe31f564.svg";
export { ForwardRef as ReactComponent };